import React from 'react';
import type { AccountProps, MyPlayerProps, PlayerBalanceProps } from '../../types';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type MyBalanceProps = {
    player:MyPlayerProps,
    player_balance:PlayerBalanceProps,
    balance_account?:AccountProps,
    walkthrough?:boolean,
    onClose:() => void,
    onNext:() => void
}

const MyBalance = ({ player_balance, onClose, onNext }:MyBalanceProps) => {
    const Colors = useColors();

    return (
        <View style={{ flex:1 }}>
             <View style={{ padding:20 }}>
                <Text size={26} theme='h1'>BETTOREDGE BALANCES</Text>
                <Text style={{ marginTop:10 }} size={16} theme='description'>All order and competition activity goes in and out of your BettorEdge balances.  The specific balance depends on which app-mode you are in.</Text>
            </View>
            <View style={{ flex:1, padding:10 }}>
                <View style={{ padding:10, paddingBottom:0 }}>
                    <Text size={18} theme='h1' textAlign='left'>APP MODES</Text>
                </View>
                <View float style={{ padding:10, borderRadius:8, margin:10 }}>
                    <View transparent style={{ padding:5, flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1 }} size={26} theme='h2'>Real-Money Mode</Text>
                        <Icons.USDIcon size={30} color={Colors.text.h1} />
                    </View>
                    <View transparent style={{ padding:5, paddingBottom:10, borderBottomWidth:1, borderBottomColor:Colors.borders.light }}>
                        <Text size={14} weight='regular' color={Colors.text.h1}>When in real-money mode.  The app header will show as this dark blue color.  All activity when in this mode will use your real-money (USD) balance.</Text>
                    </View>
                    <View transparent style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1 }} size={14} theme='description'>Real-Money / USD ($)</Text>
                        <Text size={16} weight='bold' theme='h1'>${player_balance.balance.toFixed(2)}</Text>
                    </View>
                    <View transparent style={{ padding:10 }}>
                        <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                            <Text style={{ flex:1 }} size={14} theme='description'>Promo (P)</Text>
                            <Text size={16} weight='bold' theme='h1'>P{player_balance.promo_balance.toFixed(2)}</Text>
                        </View>
                        <Text style={{ marginTop:3 }} size={12} color={Colors.text.warning} weight='semibold'>Promo balance can be used for all real-money activities. Winnings will be returned as Real-Money/USD ($).</Text>
                    </View>
                </View>
                
                <View float style={{ padding:10, borderRadius:8, margin:10 }}>
                    <View transparent style={{ padding:5, flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1 }} size={26} theme='h2'>Demo Mode</Text>
                        <Icons.EdgeCoinIcon size={30} color={Colors.text.h1} />
                    </View>
                    <View transparent style={{ padding:5, paddingBottom:10, borderBottomWidth:1, borderBottomColor:Colors.borders.light }}>
                        <Text size={14} theme='description'>When in demo mode.  The app header will show as this light blue color.  All activity when in this mode will use your Edge Coin (E) balance.</Text>
                    </View>
                    <View transparent style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1 }} size={14} theme='description'>Edge Coins (E)</Text>
                        <Text size={16} weight='bold' theme='h1'>E{player_balance.free_market_balance.toFixed(2)}</Text>
                    </View>
                </View>
            </View>
            <View nativeID='action_row' style={{ flexDirection:'row', justifyContent:'space-between', padding:10 }}>
                <Button
                    title='EXIT SETUP'
                    type='error'
                    onPress={() => onClose()}
                />
                <Button
                    float
                    style={{ borderRadius:100, height:50, width:50, justifyContent:'center', alignItems:'center' }}
                    onPress={() => onNext()}
                    >
                    <Icons.ChevronIcon size={18} direction='right' color={Colors.text.h1}/>
                </Button>
            </View>
        </View>
    )
}

export default MyBalance